import { c as t } from "./ghl-ui.es384.js";
import i from "./ghl-ui.es1158.js";
const {
  fontSize: o,
  fontFamily: e,
  lineHeight: n
} = i, r = t("body", `
 margin: 0;
 font-size: ${o};
 font-family: ${e};
 line-height: ${n};
 -webkit-text-size-adjust: 100%;
 -webkit-tap-highlight-color: transparent;
`, [t("input", `
 font-family: inherit;
 font-size: inherit;
 `)]);
export {
  r as default
};
